export default __webpack_public_path__ + "static/media/borwn-standing-raccoon.421f64e5.jpg";